import { useState } from 'react';
import Text from '@deprecated-ui/common/Text';
import Button from '@deprecated-ui/common/Button';
import color from '@deprecated-ui/_style/color';
import AuthCardLayout from 'global/AuthCardLayout';
import InputToken from 'features/register/InputTokenV2';
import TimerOtp from 'features/register/TimerOtp';
import { InputPinContainer } from '../styled';

interface VerifyEmailProps {
  onVerify: (code: string) => void;
  onChangeEmail: () => void;
  onResend: () => void;
  email?: string;
}

function VerifyEmail({
  onVerify,
  onChangeEmail,
  onResend,
  email = '',
}: VerifyEmailProps): JSX.Element {
  const [emailTokenState, setEmailTokenState] = useState<string>('');

  const handleVerifyFilled = (emailToken: string) => {
    // save emailToken to state
    // for button click
    setEmailTokenState(emailToken);

    // Previously we auto call API when all input has been filled
    // But it also could produce an infinite loop, thus
    // we opt out that feature and make it so we call API when button is clicked
  };

  const handleOnclickBtnVerify = () => {
    // HIT API verify user
    onVerify(emailTokenState);
  };

  return (
    <AuthCardLayout wrapperClassName="register">
      <Text size="24px" align="center" color={color.black}>
        Verification Code
      </Text>

      <Text
        size="16px"
        family="light"
        color={color.highgray}
        style={{ lineHeight: '135%' }}
      >
        A verification code has been sent to your email: ({email})
      </Text>

      <InputPinContainer>
        <InputToken onVerify={handleVerifyFilled} />
        <TimerOtp onResend={onResend} />
      </InputPinContainer>

      <Button
        type="primary"
        height="44px"
        onClick={handleOnclickBtnVerify}
        block
        disabled={emailTokenState?.length !== 4}
      >
        <Text family="bold" color={color.light}>
          Verify Email
        </Text>
      </Button>

      <Text align="center" size="12px" color={color.black}>
        Didn&apos;t receive email?{' '}
        <Text as="a" size="12px" onClick={onChangeEmail}>
          Change Your Email
        </Text>
      </Text>
    </AuthCardLayout>
  );
}

export default VerifyEmail;
